/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, { Component } from "react";
import Rule from "@react/react-spectrum/Rule";
import NavigationBarCss from "./NavigationBar.css";

class HorizontalSeparator extends Component {
  constructor(props) {
    super(props);
    this.style = this.getStyle();
  }

  getStyle() {
    if (this.props && this.props.style) {
      return this.props.style;
    }
  }

  render() {
    return <Rule variant="small" style={this.style} className={NavigationBarCss.HorizontalSeparator} />;
  }
}

export { HorizontalSeparator };
